import { createReducer } from '@reduxjs/toolkit';
import { showModal, hideModal } from './modalActions';
import { ModalState } from './modalModel';

export const initialState: ModalState = {
  isOpen: false,
  content: {},
};

const modalReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(showModal, (state: ModalState, action) => {
      state.isOpen = true;
      state.content = action.payload;
    })
    .addCase(hideModal, () => initialState);
});

export default modalReducer;
